import Vue from 'vue'
import Vuex from 'vuex'
import { getProjectColumns, updateTaskColumn } from '@/helpers/api/kanban'
import { getProjectRequest, isCurrentProjectRequest } from '@/helpers/projectContext'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		columnsByProject: {},
		loadingByProject: {}
	},
	mutations: {
		setProjectColumns(state, { projectId, columns }) {
			Vue.set(state.columnsByProject, projectId, columns)
		},
		upsertProjectColumn(state, column) {
			const projectId = column.project_id
			const columns = state.columnsByProject[projectId] || []
			const index = columns.findIndex(item => item.id === column.id)
			if (index === -1) columns.push(column)
			else Vue.set(columns, index, { ...columns[index], ...column })
			Vue.set(state.columnsByProject, projectId, columns.slice().sort((a, b) => a.position - b.position))
		},
		removeProjectColumn(state, { projectId, columnId }) {
			const columns = state.columnsByProject[projectId]
			if (!columns) return
			Vue.set(state.columnsByProject, projectId, columns.filter(column => column.id !== columnId))
		},
		setProjectColumnsPosition(state, { projectId, columns }) {
			if (!state.columnsByProject[projectId]) return
			const positions = columns.reduce((result, column) => {
				result[column.id] = column.position
				return result
			}, {})
			Vue.set(state.columnsByProject, projectId, state.columnsByProject[projectId]
				.map(column => ({ ...column, position: positions[column.id] ?? column.position }))
				.sort((a, b) => a.position - b.position))
		},
		setLoading(state, { projectId, loading }) {
			Vue.set(state.loadingByProject, projectId, loading)
		},
		resetForProject(state) {
			state.columnsByProject = {}
			state.loadingByProject = {}
		}
	},
	actions: {
		async getProjectColumns(context, payload) {
			const projectId = Number(payload && payload.project_id ? payload.project_id : payload)
			const force = !!(payload && payload.force)
			if (!projectId) return []
			if (!force && Object.prototype.hasOwnProperty.call(context.state.columnsByProject, projectId)) {
				return context.state.columnsByProject[projectId]
			}
			if (context.state.loadingByProject[projectId]) return context.state.columnsByProject[projectId] || []

			const request = getProjectRequest(projectId)
			context.commit('setLoading', { projectId, loading: true })
			try {
				const response = await getProjectColumns({ project_id: projectId })
				if (isCurrentProjectRequest(request.projectId, request.generation) && response.code === 200) {
					const columns = (response.columns || []).map(column => ({
						id: column.id,
						name: column.name,
						color: column.color,
						position: column.position,
						project_id: column.project_id
					}))
					context.commit('setProjectColumns', { projectId, columns })
					return columns
				}
				if (response.code === 403) {
					throw new Error(response.message || 'No tienes acceso a este proyecto.')
				}
				return []
			} finally {
				if (isCurrentProjectRequest(request.projectId, request.generation)) {
					context.commit('setLoading', { projectId, loading: false })
				}
			}
		},
		async updateTaskColumn(context, payload) {
			return updateTaskColumn(payload)
		}
	}
})

export default store
